import { Injectable } from '@angular/core';

import { ProductFurnitureSpec } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductFurnitureSpecService extends TmsWebBaseEditService<ProductFurnitureSpec, ProductFurnitureSpec> {
  constructor() {
    super('FurnitureSpec', $localize`Furniture Spec`);
  }
}
